export const STATE_NAME = "paymentModal";
export const FORM_NAME = STATE_NAME;

export const notStartedStep = 'NOT_STARTED_STEP';
export const stripeStep = 'STRIPE_STEP';
export const ccAckStep = 'CC_ACK_STEP';
export const mailAckStep = 'MAIL_ACK_STEP';
export const bankAckStep = 'BANK_ACK_STEP';
export const previousYearStep = 'PREVIOUS_YEAR_STEP';
